import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "src/app/services/auth.service";
import { PortalService } from "../../../services/portal-service.service";

@Component({
  standalone: false,
  selector: "app-delete-user",
  templateUrl: "./delete.component.html",
  styleUrls: ["./delete.component.scss"],
})
export class DeleteComponent {
  success = false;
  error: any = null;
  email: string;
  password: string;
  promptConfirm = false;
  deleting = false;

  constructor(
    private portalService: PortalService,
    private as: AuthService,
    private router: Router,
  ) {}

  async deleteUser(confirm = false) {
    if (confirm) {
      this.resetMessage();
      if (this.deleting) return;
      this.deleting = true;
      try {
        await this.portalService.deleteUser(this.email, this.password);
        this.as.logout();
        this.router.navigate(["login"]);
      } catch (error) {
        this.error = error;
        this.promptConfirm = false;
      } finally {
        this.deleting = false;
      }
    } else {
      this.resetMessage();
      this.promptConfirm = true;
    }
  }

  resetMessage() {
    this.success = false;
    this.error = null;
  }

  deleteDisabled(): boolean {
    return this.deleting || !this.email || !this.password;
  }
}
